import backendService from './backend';

/**
 * Fetches the key moments history for a given program (live event) ID.
 * Returns the response from `entitlement.v3.getKeyMomentsHistory`.
 */
export function getKeyMoments(programId) {
  return backendService.entitlement.v3.getKeyMomentsHistory(programId);
}
